













































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
// import Editor from '@/components/Editor/single-editor.vue'
import MarkdownEditor from '@/components/MarkdownEditor/index.vue'
import { getArticleCategory, getArticleTagList, editArticle, getArticleData } from '@/api/content/content-news/news'
import { AppModule } from '@/store/modules/app'
import { sizeTostr } from '@/utils/tool'
import { uploadImgUrl, uploadVideoUrl } from '@/api/upload'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

type content = {
  id: number,
  lang: string,
  title: string,
  author: string,
  content: string
}

@Component({
  name: 'NewsEdit',
  components: {
    Editor,
    Toolbar,
    MarkdownEditor
  }
})
export default class extends mixins(DisplayMixin) {
  params: any = {
    id: 0,
    relateAppID: '',
    publishedDate: '',
    blockId: 0,
    coverURL: '',
    contentList: [],
    tagIds: [],
    keywords: '',
    description: ''
  }
  cids: number[] = []
  tagIds: number[] = []
  classifyList: any[] = []
  contentList: content[] = []
  activeIndex = 0
  currentLang: string = 'en-us'
  selectedLang: string[] = []
  value: string = ''
  currentContent: content = {
    id: 0,
    lang: 'en-us',
    title: '',
    author: '',
    content: ''
  }
  tagList: any[] = []
  cateList: any[] = []
  articleData: any = {}
  editor: string = ''
  subTile: string = ''
  wangeditor: any = null
  toolbarConfig: any = {}
  editorConfig: any = {
    placeholder: '请输入内容...',
    MENU_CONF: {
      uploadImage: {
        // 上传图片的配置
        server: uploadImgUrl,
        fieldName: 'file',
        maxFileSize: 5 * 1024 * 1024,
        maxNumberOfFiles: 10,
        meta: {
          type: 7,
          'no_compress': 1
        },
        // headers: {
        //   'X-Access-Token': getCookie('token')
        // },
        // 跨域是否传递 cookie ，默认为 false
        withCredentials: false,
        // 超时时间，默认为 10 秒
        timeout: 60 * 1000, // 5 秒
        customInsert(res: any, insertFn: Function) {
          // TS 语法
          // customInsert(res, insertFn) {                  // JS 语法
          // res 即服务端的返回结果
          // 从 res 中找到 url alt href ，然后插入图片
          let url = res.data
          insertFn(url, '', url)
        }
      }
      // uploadVideo: {
      //   server: uploadVideoUrl,
      //   fieldName: 'file',
      //   maxFileSize: 30 * 1024 * 1024,
      //   maxNumberOfFiles: 5,
      //   timeout: 60 * 1000,
      //   customInsert(res: any, insertFn: Function) {
      //     console.log(res)
      //     let url = res.data
      //     insertFn(url, '')
      //   }
      // }
    }
  }
  html: string = ''
  mode: string = 'default' // or 'simple'
  editorKey: number = 1
  textLength: number = 0

  async created() {
    const query = this.$route.query
    if (+query.id) {
      await this.getDetail(query.id as string)
    } else {
      this.selectedLang = ['en-us']
    }
    try {
      let userInfo = JSON.parse(localStorage.getItem('userInfo') as string)
      this.editor = userInfo.userName
    } catch (err) {
      console.log(err)
    }
    await Promise.all([getArticleCategory(), getArticleTagList()]).then(([res, res1]: any[]) => {
      this.cateList = res.data.dataList || []
      this.tagList = res1.data.dataList || []
      let radio = this.params.blockId
      if (radio === 1) {
        this.classifyList = this.tagList
      } else if (radio === 2) {
        this.classifyList = this.cateList
      } else {
        this.classifyList = []
      }
    })
    this.updateContent()
  }

  beforeDestroy() {
    const editor: any = this.wangeditor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  }

  updateContent() {
    let langs:string[] = this.langList.map((item: any) => item.code)
    let obj: any = {}
    const { contentList } = this.params
    langs.forEach(key => {
      let value = contentList.find((item: any) => item.lang === key)
      obj[key] = value || null
    })
    this.articleData = obj
    this.articleData[this.currentContent['lang']] = this.currentContent
  }

  onChange(editor: any) {
    if (!editor) {
      this.textLength = 0
      return
    }
    // 全部文字
    const text = editor.getText().replace(/\n|\r/mg, '')
    this.textLength = text.length
  }

  onCreated(editor: any) {
    this.wangeditor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
  }

  handleGetSize(size: number) {
    this.subTile = sizeTostr(size)
  }

  async getDetail(id: string) {
    const res: any = await getArticleData({ id })
    const { data, status: { code } } = res
    if (+code === 0) {
      this.params = data
      this.params.relateAppID = +data.relateAppID || ''
      this.currentContent = data.contentList[0]
      this.selectedLang = data.contentList.map((item: any) => item.lang)
      this.tagIds = data[+data.blockId === 1 ? 'tagIds' : 'cids']
    }
  }

  formatParams() {
    let obj: any = { ...this.params }
    obj.relateAppID = +obj.relateAppID || 0
    obj.tagIds = []
    obj.cids = []
    if (obj.blockId === 1) obj.tagIds = this.tagIds
    if (obj.blockId === 2) obj.cids = this.tagIds
    let arr: any[] = []
    this.selectedLang.forEach(lang => {
      arr.push(this.articleData[lang])
    })
    obj.contentList = arr
    return obj
  }

  handleSwitch(radio: number) {
    this.tagIds = []
    if (radio === 1) {
      this.classifyList = this.tagList
    } else if (radio === 2) {
      this.classifyList = this.cateList
    } else {
      this.classifyList = []
    }
  }

  handleSwitchLanguage(lang: string, index: number) {
    this.editorKey++
    this.currentLang = lang
    this.activeIndex = index
    this.currentContent = this.articleData[lang]
  }

  handleChange(val: string[]) {
    let obj: any = {}
    if (val.length === 0) {
      this.selectedLang = ['en-us']
    }
    val.forEach(key => {
      let item = {
        id: 0,
        lang: key,
        title: '',
        author: this.editor,
        content: ''
      }
      obj[key] = this.articleData[key] || item
    })
    this.articleData = obj
    console.log(this.articleData)
  }

  checkParams() {
    if (this.currentContent.title.length <= 0) return '请输入资讯标题'
    if (this.params.blockId <= 0) return '请选择发布版块'
    if (this.tagIds.length <= 0) return `请选择${this.params.blockId === 1 ? 'TAG' : '分类'}`
    if (!this.params.publishedDate) return '请选择发布时间'
    if (this.currentContent.content.trim().length <= 0) return '请输入文章内容'
    if (!this.params.coverURL) return '请上传封面图'
  }
  async handeSubmit() {
    let warning = this.checkParams()
    let p = this.formatParams()
    console.log(p)
    if (warning) return this.$message.warning(warning)
    const res: any = await editArticle(p)
    console.log(res)
    if (+res.status.code === 0) {
      this.$message.success(+this.$route.query.id ? '修改成功' : '创建成功')
      setTimeout(() => {
        this.$router.push('/content/content-news/news-list')
      }, 1000)
    }
  }

  get getTitle() {
    if (+this.params.blockId === 1) {
      return 'TAG'
    } else if (+this.params.blockId === 2) {
      return '分类'
    } else {
      return 'TAG/分类'
    }
  }

  get placeholder() {
    return `选择${this.getTitle}`
  }

  get langList() {
    return AppModule.languageList
  }

  get langMap() {
    let map: string[][] = AppModule.languageList.map((item: any) => [item.code, item.name])
    return new Map(map as any[])
  }

  get item() {
    return {
      text: this.currentContent.content,
      title: this.currentContent.title
    }
  }

  @Watch('langList')
  onLangListChange(val: any[]) {
    let langs:string[] = val.map((item: any) => item.code)
    let obj: any = {}
    langs.forEach(key => {
      obj[key] = null
    })
    this.articleData = obj
    this.articleData[this.currentContent['lang']] = this.currentContent
  }

  @Watch('currentContent')
  onUpdate(newVal: any) {
    this.html = newVal.content
  }
}
